import CaseStatusApi from "@/api/case-status";
import {
  Option,
  SelectBox,
  SelectBoxProps,
} from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";

type CaseStatusRecord = {
  case_status_id: number;
  status_name: string;
};

export type CaseStatusSelectorProps = Omit<
  SelectBoxProps,
  | "data"
  | "renderOption"
  | "OptionTooltip"
  | "searchFn"
  | "onScroll"
  | "searchable"
  | "loading"
  | "defaultValue"
  | "value"
> & {
  defaultValue?: Option;
  value?: Option;
};

export const CaseStatusSelector: React.FC<CaseStatusSelectorProps> = (
  props
) => {
  const { data, isLoading } = useQuery({
    queryKey: ["case-statuses", "list"],
    queryFn: () => CaseStatusApi.getCaseStatuses(),
  });

  const records: CaseStatusRecord[] = data || [];

  // Combine number and name in label for client-side search by either
  const options: Option[] = records.map((item) => ({
    label: item.status_name,
    value: item.status_name,
    data: item,
  }));

  return (
    <SelectBox
      placeholder="Select or search for a case status..."
      {...props}
      data={options}
      searchable={true}
      loading={isLoading}
    />
  );
};
